import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { styles } from './styles';

const WebchatWindow = ({ classes, active }) => (
  <div
    id="chatContainer"
    className={`${classes.root} ${active ? classes.active : ''}`}
  />
);

WebchatWindow.defaultPropTypes = {
  classes: {},
  active: false,
};

WebchatWindow.propTypes = {
  classes: PropTypes.object.isRequired,
  active: PropTypes.bool,
};

export default withStyles(styles)(WebchatWindow);
